import type React from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';
import { Radio, RadioGroup } from '@change-corgi/design-system-legacy/components/forms';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

type Props = {
	paymentTerm: 'one-time' | 'monthly' | 'yearly';
	name: string;
	showYearlyPaymentTerm: boolean;
	showOneTimePaymentTerm: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const MembershipPaymentTermSelector: React.FC<Props> = ({
	paymentTerm,
	onChange,
	name,
	showYearlyPaymentTerm,
	showOneTimePaymentTerm,
}) => {
	const { translate } = useI18n();

	const isSunriseTheme = useIsSunriseTheme();

	if (!showYearlyPaymentTerm && !showOneTimePaymentTerm) return null;

	return (
		<Box sx={{ pb: 16 }}>
			<RadioGroup id={name} data-qa="payment-term-selector" defaultValue={paymentTerm}>
				<Flex sx={{ flex: 1, flexDirection: 'row' }}>
					{!!showOneTimePaymentTerm && (
						<Flex sx={{ flex: 1 }}>
							<Radio
								label={translate('corgi.membership.payment_form.terms.one_time')}
								value="one-time"
								name={name}
								data-testid={`${name}-one-time-radio`}
								checked={paymentTerm === 'one-time'}
								onChange={onChange}
								sx={{ ...(isSunriseTheme && { accentColor: 'sunrise.semantic.icon.accent.primary' }) }}
							/>
						</Flex>
					)}
					<Flex sx={{ flex: 1 }}>
						<Radio
							label={translate('corgi.membership.payment_form.terms.monthly')}
							value="monthly"
							name={name}
							data-testid={`${name}-monthly-radio`}
							checked={paymentTerm === 'monthly'}
							onChange={onChange}
							sx={{ ...(isSunriseTheme && { accentColor: 'sunrise.semantic.icon.accent.primary' }) }}
						/>
					</Flex>
					{!!showYearlyPaymentTerm && (
						<Flex sx={{ flex: 1 }}>
							<Radio
								label={translate('corgi.membership.payment_form.terms.yearly')}
								value="yearly"
								name={name}
								data-testid={`${name}-yearly-radio`}
								checked={paymentTerm === 'yearly'}
								onChange={onChange}
								sx={{ ...(isSunriseTheme && { accentColor: 'sunrise.semantic.icon.accent.primary' }) }}
							/>
						</Flex>
					)}
				</Flex>
			</RadioGroup>
		</Box>
	);
};
